<template>
  <div class="create-form">
    <News :id="id" :type="type" v-if="type === 'news' || type === 'api'" @back="back" />
    <WeMedia
      :id="id"
      :type="type"
      v-else-if="
        type === 'twitter' || type === 'weibo' || type === 'facebook' || type === 'youtube'
      "
      @back="back"
    />
    <Toutiao :id="id" :type="type" v-else-if="type === 'toutiao'" @back="back" />
    <Document :id="id" :type="type" v-else-if="type === 'document'" @back="back"></Document>
    <div class="type-box">
      <img :src="require(`./img/${type}.png`)" alt="" />
      <p>{{ nameMap[type] }}</p>
    </div>
  </div>
</template>
<script>
import News from './News/'
import WeMedia from './WeMedia/'
import Toutiao from './Toutiao'
import Document from './Document'

export default {
  components: {
    News,
    WeMedia,
    Toutiao,
    Document
  },
  data() {
    return {
      type: 'news',
      id: '',
      nameMap: {
        news: '新闻',
        facebook: 'Facebook',
        toutiao: '头条',
        twitter: '推特',
        weibo: '微博',
        youtube: 'Youtube',
        api: '云采集',
        document: '文献'
      }
    }
  },
  created() {
    // let { type } = this.$route.query
    // if (type) {
    //   this.type = type
    // }
  },
  methods: {
    sendData(id, type) {
      this.id = id
      this.type = type
    },
    back() {
      this.$emit('back')
    }
  }
}
</script>

<style lang="less" scoped>
.create-form {
  padding: 25px;
  position: relative;
}
.type-box {
  width: 200px;
  position: absolute;
  text-align: center;
  right: 0px;
  top: 60px;
  img {
    width: 106px;
    height: 106px;
    margin-bottom: 15px;
    box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
  }
  p {
    font-size: 22px;
    font-weight: bold;
    color: #333;
  }
}
</style>
